'use client';

import './styles/@theme';

import { useStore } from '@/store/store';
import { SvgLoader } from '@/app/elements/svg/loader';
import { getText } from '@/utils/text/text';
import { getNavigatedToProps } from '@/tracking/amplitude/events/general/navigation-link-clicked';
import { ddStartVital } from '@/utils/datadog';
import { SEARCH_VITALS, SEARCH_VITAL_DESCRIPTIONS } from '@/utils/datadog/vitals';

export const Search = () => {
    const search = useStore((s) => s.search);
    const { sendEvent } = useStore((state) => state.tracking);

    if (search.isSearchOpen) {
        return null;
    }

    const handleClick = () => {
        ddStartVital(
            SEARCH_VITALS.RECOMMENDED_READY,
            { description: SEARCH_VITAL_DESCRIPTIONS[SEARCH_VITALS.RECOMMENDED_READY] },
            { replace: true }
        );
        const eventProps = getNavigatedToProps({
            module: 'top_bar',
            linkText: 'search',
            linkUrl: '/search',
            linkType: 'non_category'
        });
        sendEvent([{ destination: 'amplitude', eventProps }]);
        search.toggleIsSearchOpen();
    };

    return (
        <button className="search" onClick={handleClick}>
            <SvgLoader iconName="search-magnifying-glass" />
            <span className="text">{getText({ text: 'components.search.searchLabel' })}</span>
        </button>
    );
};
